import { useEffect } from "react";

import { getResourceLinkHandler } from "../chat.helpers";
import type { McpResourceLink } from "../chat.types";
import { useChat } from "../providers/chat-provider";

/**
 * Fires `onFirstSeen` exactly once for a resource link that appears during streaming.
 * Shared by the text-link button and the generated-draft card so diverting `qw.draft.*`
 * into a card bucket cannot drop the inbox compose-window auto-open.
 */
export const useResourceLinkFirstSeen = (resource: McpResourceLink) => {
  const { resourceLinkHandlers, markResourceSeen } = useChat();
  const handler = getResourceLinkHandler(resource, resourceLinkHandlers);

  useEffect(() => {
    if (handler?.onFirstSeen && markResourceSeen(resource.uri)) {
      void handler.onFirstSeen(resource);
    }
  }, [handler, resource, markResourceSeen]);

  return handler;
};
